import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel-section p-bottom-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "has-text-weight-semibold" }, "Point of contact", -1)
const _hoisted_3 = { class: "m-left-8 m-bottom-12" }
const _hoisted_4 = { class: "has-text-red t--strikethrough" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Search staff", -1)
const _hoisted_9 = {
  key: 0,
  class: "field"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "help" }, " Reassign the current point of contact's tasks to the new point of contact? Uncheck this to add the current point of contact as support staff and keep the current task assignment. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_NrTooltip = _resolveComponent("NrTooltip")!
  const _component_NrSelect = _resolveComponent("NrSelect")!
  const _component_NrFormInput = _resolveComponent("NrFormInput")!
  const _component_NrModal = _resolveComponent("NrModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["is-flex is-align-items-center is-justify-content-space-between", {
        'panel-item panel-item--editable': _ctx.$can('manage', 'Request')
      }])
    }, [
      _hoisted_2,
      (_ctx.$can('manage', 'Request'))
        ? (_openBlock(), _createBlock(_component_NrTooltip, {
            key: 0,
            label: "Change point of contact"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_NrIconButton, {
                variant: "minimal-neutral",
                icon: { name: 'pencil-alt', type: 'regular' },
                "aria-label": "Change point of contact",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setCurrentAction('edit-poc')))
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.request.poc.undeliverable_email)
        ? (_openBlock(), _createBlock(_component_NrTooltip, {
            key: 0,
            label: "Mail to this address has been returned as undeliverable"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.request.poc.email_or_name), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_ctx.request.poc.undeliverable_email)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
            ($options.staffDepartmentsWithPocLabel() != '')
              ? (_openBlock(), _createBlock(_component_NrTooltip, {
                  key: 0,
                  label: $options.staffDepartmentsWithPocLabel()
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.request.poc.email_or_name), 1)
                  ]),
                  _: 1
                }, 8, ["label"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.request.poc.email_or_name), 1))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_NrModal, {
      "primary-button-text": "Change contact",
      "secondary-button-text": "Cancel",
      title: "Change Point of Contact",
      "has-secondary-button": true,
      show: _ctx.currentAction === 'edit-poc',
      onOnCloseClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setCurrentAction(null))),
      onOnPrimaryClick: $options.submitForm,
      onOnSecondaryClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setCurrentAction(null)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_NrSelect, {
            modelValue: $data.selectedPoc,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.selectedPoc) = $event)),
            filterable: false,
            placeholder: "Search and select staff",
            options: $options.filteredStaff,
            loading: _ctx.dataFetchState.staff.fetching,
            hasMore: !_ctx.dataFetchState.staff.end,
            onLoadMore: $options.handleStaffScroll,
            onSearch: $options.filterStaff,
            onOpen: $options.filterStaff,
            "append-to-body": ""
          }, {
            label: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["modelValue", "options", "loading", "hasMore", "onLoadMore", "onSearch", "onOpen"])
        ]),
        (_ctx.request.poc.has_tasks)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_NrFormInput, {
                type: "checkbox",
                label: "Reassign tasks",
                name: "reassign_tasks",
                modelValue: $data.reassignTasks,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.reassignTasks) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_10
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show", "onOnPrimaryClick"])
  ]))
}